export const data = {
  playgrounds: [
    {
      index: 0,
      name: 'Boloňská (workout)',
      image: 'hriste-bolonska-workout.jpg',
      gps: '50.0472881N, 14.5591139E',
      latitude: 50.0472881,
      longitude: 14.5591139,
      address: '(vedle MŠ)',
      id: 'bolonska-workout',
      elements: ['houpačka', 'síťová houpačka', 'provazová prolézačka'],
      shadow: true,
      shadowDetails: 'stín jen odpoledne',
      toys: false,
      surface: ['tartan'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 1,
      name: 'Galvaniho',
      image: 'hriste-galvaniho.jpg',
      gps: '50.0394717N, 14.5587744E',
      latitude: 50.0394717,
      longitude: 14.5587744,
      address: '(u polikliniky Petrovice)',
      id: 'galvaniho',
      elements: ['houpačka pro dvojice', 'skluzavka', 'mini kolotoč'],
      shadow: false,
      shadowDetails: null,
      toys: false,
      surface: ['písek'],
      cityPart: 'Petrovice',
    },
    {
      index: 2,
      name: 'Lánská',
      image: 'hriste-lanska.jpg',
      gps: '50.0459972N, 14.5580808E',
      latitude: 50.0459972,
      longitude: 14.5580808,
      address: '(u zastávky Na Vartě)',
      id: 'lanska',
      elements: ['skluzavka', 'velká prolézačka ve tvaru lodi'],
      shadow: true,
      shadowDetails: 'stín jen v podvečer',
      toys: false,
      surface: ['kamínky'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 3,
      name: 'Lessnerova',
      image: 'hriste-lessnerova-2.jpg',
      gps: '50.0393797N, 14.5596467E',
      latitude: 50.0393797,
      longitude: 14.5596467,
      address: '(vedle polikliniky Petrovice)',
      id: 'lessnerova',
      elements: ['pískoviště', 'houpací želva'],
      shadow: true,
      shadowDetails: null,
      toys: true,
      surface: ['písek'],
      cityPart: 'Petrovice',
    },
    {
      index: 4,
      name: 'Milánská',
      image: 'hriste-milanska.jpg',
      gps: '50.0431839N, 14.5544361E',
      latitude: 50.0431839,
      longitude: 14.5544361,
      address: '(u zastávky Bolevecká)',
      id: 'milanska',
      elements: [
        'malá houpačka',
        'houpačka',
        'houpačka pro dvojice',
        'pískoviště',
        'skluzavka',
        'kolotoč',
      ],
      shadow: true,
      shadowDetails: 'stín jen odpoledne',
      toys: true,
      surface: ['písek'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 5,
      name: 'Milánská',
      image: 'hriste-milanska-tartan.jpg',
      gps: '50.0431464N, 14.5546875E',
      latitude: 50.0431464,
      longitude: 14.5546875,
      address: '(u zastávky Bolevecká)',
      id: 'milanska-tartan',
      elements: [
        'skluzavka',
        'trampolínka',
        'kopečky na přelézání s otvory na kuličky',
        'namalované hry (člověče nezlob se, zrcadlo, dráha s čísly, zvířata, skákání...)',
      ],
      shadow: false,
      shadowDetails: null,
      toys: false,
      surface: ['tartan'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 6,
      name: 'Milánská/Bolevecká',
      image: 'hriste-milanska-bolevecka.jpg',
      gps: '50.0428611N, 14.5564131E',
      latitude: 50.0428611,
      longitude: 14.5564131,
      address: '(u zastávky Bolevecká)',
      id: 'milanska-bolevecka',
      elements: ['skluzavka', 'prolézačky'],
      shadow: false,
      shadowDetails: null,
      toys: false,
      surface: ['kamínky'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 7,
      name: 'Milánská/Livornská',
      image: 'hriste-milanska-livornska.jpg',
      gps: '50.0408117N, 14.5545333E',
      latitude: 50.0408117,
      longitude: 14.5545333,
      address: '(v zatáčce ulice Milánská)',
      id: 'milanska-livornska',
      elements: [
        'malá houpačka',
        'houpačka',
        'houpačka pro dvojice',
        'pískoviště',
        'houpací koník',
        'mini kolotoč',
        'hrazdy',
        'kladina',
        'vysoké provazové prolézačky',
      ],
      shadow: true,
      shadowDetails: 'stín jen dopoledne',
      toys: true,
      surface: ['písek'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 8,
      name: 'Morseova',
      image: 'hriste-morseova-3.jpg',
      gps: '50.0364228N, 14.5567611E',
      latitude: 50.0364228,
      longitude: 14.5567611,
      address: '(vedle tenisových kurtů)',
      id: 'morseova',
      elements: [
        'houpačka pro dvojice',
        'skluzavka',
        'houpací koník',
        'mini kolotoč',
        'síť pohyblivých kloboučků na přeskakování',
        'vysoká prolézačka',
      ],
      shadow: true,
      shadowDetails: 'stín částečně pod stromy',
      toys: false,
      surface: ['tartan'],
      cityPart: 'Petrovice',
    },
    {
      index: 9,
      name: 'Veronské náměstí',
      image: 'hriste-veronske-namesti-albert-1.jpg',
      gps: '50.0409669N, 14.5574619E',
      latitude: 50.0409669,
      longitude: 14.5574619,
      address: '(u Alberta)',
      id: 'veronske-albert',
      elements: [
        'malá houpačka',
        'houpačka',
        'pískoviště',
        'skluzavka',
        'kolotoč',
        'houpací želva',
        'domeček',
      ],
      shadow: true,
      shadowDetails: 'stín jen nad pískovištěm, nad celým hřištěm v podvečer',
      toys: true,
      surface: ['písek'],
      cityPart: 'Horní Měcholupy',
    },
  ],
  outdoorSpaces: [
    {
      index: 0,
      id: 'divoka-zahrada-hostivar',
      name: 'Divoká zahrada Hostivař',
      image: 'outdoor-spaces.svg',
      gps: '50.0401453N, 14.5173678E',
      latitude: 50.0401453,
      longitude: 14.5173678,
      address: 'na konci ulice K Obecním hájovnám',
      web:
        'https://lhmp.cz/zachranna-stanice/lesni-zookoutky/divoka-zahrada-hostivar/',
      cityPart: 'Hostivař',
    },
    {
      index: 1,
      id: 'dobra-voda-potucek',
      name: 'Dobrá voda potůček',
      image: 'outdoor-spaces.svg',
      gps: '50.0300175N, 14.5632119E',
      latitude: 50.0300175,
      longitude: 14.5632119,
      address: 'Na Dobré vodě, Praha',
      web: '',
      cityPart: 'Křeslice',
    },
    {
      index: 2,
      id: 'dopravni-hriste-horni-mecholupy',
      name: 'Dopravní hřiště Horní Měcholupy',
      image: 'outdoor-spaces.svg',
      gps: '50.0393753N, 14.5629506E',
      latitude: 50.0393753,
      longitude: 14.5629506,
      address: 'Veronské nám. 391, Praha 15',
      web: 'http://www.zsvn.cz/skola/dopravni-hriste',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 3,
      id: 'dopravni-hriste-platanova',
      name: 'Dopravní hřiště Platanová',
      image: 'outdoor-spaces.svg',
      gps: '50.0555522N, 14.5093764E',
      latitude: 50.0555522,
      longitude: 14.5093764,
      address: 'Platanová ulice, Praha 10',
      web:
        'https://praha10.cz/sport/volny-cas/detska-hriste/prm/view/id/39049/dopravni-hriste-platanova',
      cityPart: 'Záběhlice',
    },
    {
      index: 4,
      id: 'gutovka',
      name: 'Gutovka',
      image: 'gutovka.png',
      gps: '50.0711136N, 14.4910036E',
      latitude: 50.0711136,
      longitude: 14.4910036,
      address: 'Gutova 39, Praha 10',
      web: 'https://www.gutovka.cz/',
      cityPart: 'Strašnice',
    },
    {
      index: 5,
      id: 'hostivarsky-lesopark',
      name: 'Hostivařský lesopark',
      image: 'outdoor-spaces.svg',
      gps: '50.0451481N, 14.5369528E',
      latitude: 50.0451481,
      longitude: 14.5369528,
      address: 'Lesopark Hostivař',
      web: 'http://www.praha-priroda.cz/lesy/hostivarsky-lesopark/',
      cityPart: 'Hostivař',
    },
    {
      index: 6,
      id: 'krtkuv-svet',
      name: 'Krtkův svět',
      image: 'krtkuv-svet.png',
      gps: '50.0508917N, 14.5655572E',
      latitude: 50.0508917,
      longitude: 14.5655572,
      address: 'K Měcholupům 777, Praha 15',
      web: 'https://krtkuvsvet.cz/',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 7,
      id: 'malesicky-park',
      name: 'Malešický park',
      image: 'outdoor-spaces.svg',
      gps: '50.0850017N, 14.4990378E',
      latitude: 50.0850017,
      longitude: 14.4990378,
      address: 'Malešická ulice, Praha 10',
      web:
        'https://www.praha.eu/jnp/cz/o_meste/zivot_v_praze/mapa_detskych_hrist/praha_10/malesicky_park.html',
      cityPart: 'Malešice',
    },
    {
      index: 8,
      id: 'milicov-zoopark',
      name: 'Milíčov zoopark',
      image: 'outdoor-spaces.svg',
      gps: '50.0280586N, 14.5398583E',
      latitude: 50.0280586,
      longitude: 14.5398583,
      address: 'K Milíčovu 100/8, Praha 11',
      web:
        'https://www.facebook.com/Zoopark-Mil%C3%AD%C4%8Dov-2035774800011674/',
      cityPart: 'Háje',
    },
    {
      index: 9,
      id: 'milicovsky-les',
      name: 'Milíčovský les',
      image: 'outdoor-spaces.svg',
      gps: '50.0218064N, 14.5378878E',
      latitude: 50.0218064,
      longitude: 14.5378878,
      address: 'Praha Újezd',
      web: 'http://www.praha-priroda.cz/lesy/milicovsky-les/',
      cityPart: 'Újezd',
    },
    {
      index: 10,
      id: 'na-sancich',
      name: 'Na Šancích',
      image: 'outdoor-spaces.svg',
      gps: '50.0379197N, 14.5479481E',
      latitude: 50.0379197,
      longitude: 14.5479481,
      address: 'Turínská 1494/1, Praha 15',
      web: 'https://www.nasancich.cz/',
      cityPart: 'Hostivař',
    },
    {
      index: 11,
      id: 'park-malinova-chrpova',
      name: 'Park Malinová-Chrpová',
      image: 'outdoor-spaces.svg',
      gps: '50.0568297N, 14.5012389E',
      latitude: 50.0568297,
      longitude: 14.5012389,
      address: 'Malinová a Chrpová ulice, Praha 10',
      web:
        'https://verejneprostory.cz/projekty/realizovane/park-malinova-chrpova',
      cityPart: 'Záběhlice',
    },
    {
      index: 12,
      id: 'park-u-chodovské-tvrze',
      name: 'Park u Chodovské tvrze',
      image: 'outdoor-spaces.svg',
      gps: '50.0346300N, 14.4990133E',
      latitude: 50.03463,
      longitude: 14.4990133,
      address: 'Ledvinova 9/86, Praha 11',
      web: 'https://chodovskatvrz.cz/',
      cityPart: 'Chodov',
    },
    {
      index: 13,
      id: 'plaz-hostivarska-prehrada',
      name: 'pláž Hostivařská přehrada',
      image: 'outdoor-spaces.svg',
      gps: '50.0410653N, 14.5333978E',
      latitude: 50.0410653,
      longitude: 14.5333978,
      address: 'K Jezeru, Praha 15',
      web: 'http://www.hostivarskaprehrada.cz/',
      cityPart: 'Hostivař',
    },
    {
      index: 14,
      id: 'toulcuv-dvur',
      name: 'Toulcův dvůr',
      image: 'toulcuv-dvur.png',
      gps: '50.0482556N, 14.5200314E',
      latitude: 50.0482556,
      longitude: 14.5200314,
      address: 'Kubatova 32/1, Praha 15',
      web: 'https://www.toulcuvdvur.cz/',
      cityPart: 'Hostivař',
    },
  ],
  innerSpaces: [
    {
      index: 0,
      id: 'aqua-sport-club-areal',
      name: 'Aqua Sport Club',
      image: 'jedenactka.png',
      gps: '50.0386019N, 14.5016939E',
      latitude: 50.0386019,
      longitude: 14.5016939,
      address: 'Mírového hnutí 2385/3, Praha 11',
      web: 'https://www.aquasportclub.cz/plavecky-bazen/',
      cityPart: 'Chodov',
    },
    {
      index: 1,
      id: 'aquapalace-praha',
      name: 'Aquapalace Praha',
      image: 'aqua-palace.png',
      gps: '50.0075761N, 14.5714894E',
      latitude: 50.0075761,
      longitude: 14.5714894,
      address: 'Pražská 138, Čestlice',
      web: 'https://www.aquapalace.cz/',
      cityPart: 'Čestlice',
    },
    {
      index: 2,
      id: 'funpark-zirafa',
      name: 'FunPark Žirafa',
      image: 'funpark-zirafa.png',
      gps: '50.0000764N, 14.5768128E',
      latitude: 50.0000764,
      longitude: 14.5768128,
      address: 'Obchodní 106, Čestlice',
      web: 'http://www.funparkzirafa.cz/',
      cityPart: 'Čestlice',
    },
    {
      index: 3,
      id: 'hamr-zaběhlice',
      name: 'Hamr Záběhlice',
      image: 'hamr.png',
      gps: '50.0530586N, 14.4860553E',
      latitude: 50.0530586,
      longitude: 14.4860553,
      address: 'K vodě 3200/3, Praha 10',
      web: 'http://www.hamrsport.cz/cs/detsky_koutek/',
      cityPart: 'Záběhlice',
    },
    {
      index: 4,
      id: 'jump-arena',
      name: 'Jump arena',
      image: 'jump-park.png',
      gps: '50.0671017N, 14.5473775E',
      latitude: 50.0671017,
      longitude: 14.5473775,
      address: 'Kutnohorská 532, Praha 10',
      web: 'https://www.jumpjumpjump.cz/',
      cityPart: 'Štěrboholy',
    },
    {
      index: 5,
      id: 'koala',
      name: 'Koala',
      image: 'koala-cafe.png',
      gps: '50.0561431N, 14.5429808E',
      latitude: 50.0561431,
      longitude: 14.5429808,
      address: 'Dolnoměcholupská 209/17, Praha 15',
      web: 'http://www.koalacafe.cz',
      cityPart: 'Hostivař',
    },
    {
      index: 6,
      id: 'kuliskov',
      name: 'Kulíškov',
      image: 'kuliskov.png',
      gps: '50.0534133N, 14.5178375E',
      latitude: 50.0534133,
      longitude: 14.5178375,
      address: 'Švehlova 1391/32, Praha 15',
      web: 'https://www.kuliskov.cz/',
      cityPart: 'Hostivař',
    },
    {
      index: 7,
      id: 'piratsky-detsky-svet',
      name: 'Pirátský dětský svět',
      image: 'inner-spaces.svg',
      gps: '50.0725097N, 14.5421122E',
      latitude: 50.0725097,
      longitude: 14.5421122,
      address: 'Nákupní 389/3, Praha 10',
      web: 'http://www.europark.cz/cz/piratsky_detsky_svet',
      cityPart: 'Štěrboholy',
    },
    {
      index: 8,
      id: 'plavacek-pronajem-bazenu',
      name: 'Plaváček - pronájem bazénu',
      image: 'plavacek.png',
      gps: '50.0455339N, 14.5581889E',
      latitude: 50.0455339,
      longitude: 14.5581889,
      address: 'Milánská 311, Praha 15',
      web: 'https://www.plavani.com',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 9,
      id: 'slunecnice',
      name: 'Slunečnice',
      image: 'slunecnice.png',
      gps: '50.0253447N, 14.4926225E',
      latitude: 50.0253447,
      longitude: 14.4926225,
      address: 'Vojtíškova 1783/2, Praha 11',
      web: 'https://www.detske-centrum-slunecnice.cz/',
      cityPart: 'Chodov',
    },
    {
      index: 10,
      id: 'tanzania',
      name: 'Tanzania',
      image: 'tanzania.png',
      gps: '50.0406161N, 14.5588367E',
      latitude: 50.0406161,
      longitude: 14.5588367,
      address: 'Veronské náměstí 403, Praha 15',
      web: 'https://www.tanzania-park.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 11,
      id: 'time-out',
      name: 'Time Out',
      image: 'timeout.png',
      gps: '50.0312078N, 14.4902753E',
      latitude: 50.0312078,
      longitude: 14.4902753,
      address: 'Roztylská 2321/19, Praha 11',
      web: 'https://www.timeoutplus.cz/koutky.php?page=CZ_C_CH',
      cityPart: 'Chodov',
    },
  ],
  restaurants: [
    {
      index: 0,
      id: 'bageterie-boulevard',
      name: 'Bageterie Boulevard',
      image: 'bb.png',
      gps: '50.0434989N, 14.5676031E',
      latitude: 50.0434989,
      longitude: 14.5676031,
      address: 'Hornoměcholupská 764, Praha 15',
      web: 'http://www.bb.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 1,
      id: 'cyklobar-ve-statku',
      name: 'Cyklobar Ve Statku',
      image: 'restaurants.svg',
      gps: '50.0244522N, 14.5555886E',
      latitude: 50.0244522,
      longitude: 14.5555886,
      address: 'Ke Štítu 33, Praha',
      web: '',
      cityPart: 'Křeslice',
    },
    {
      index: 2,
      id: 'dolce-carosello',
      name: 'Dolce Carosello',
      image: 'dolce-carosello.png',
      gps: '50.0756758N, 14.5004539E',
      latitude: 50.0756758,
      longitude: 14.5004539,
      address: 'Turnovského 497/2, Praha 10',
      web: 'https://www.dolce-carosello.cz',
      cityPart: 'Strašnice',
    },
    {
      index: 3,
      id: 'hostivar-1',
      name: 'Hostivar 1',
      image: 'hostivar.png',
      gps: '50.0463689N, 14.5493519E',
      latitude: 50.0463689,
      longitude: 14.5493519,
      address: 'Lochotínská 656, Praha 15',
      web: 'https://www.pivovar-hostivar.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 4,
      id: 'hostivar-2',
      name: 'Hostivar H2',
      image: 'hostivar.png',
      gps: '50.0494186N, 14.5615542E',
      latitude: 50.0494186,
      longitude: 14.5615542,
      address: 'Hornoměcholupská 750/115, Praha 15',
      web: 'https://www.pivovar-hostivar.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 5,
      id: 'kavarna-jasminka',
      name: 'Kavárna Jasmínka',
      image: 'jasminka.png',
      gps: '50.0554542N, 14.5118408E',
      latitude: 50.0554542,
      longitude: 14.5118408,
      address: 'Jasmínová 2905/37, Praha 10',
      web: 'http://www.kavarnajasminka.cz/',
      cityPart: 'Záběhlice',
    },
    {
      index: 6,
      id: 'koala-cafe-restaurant',
      name: 'Koala café',
      image: 'koala-cafe.png',
      gps: '50.0561431N, 14.5429808E',
      latitude: 50.0561431,
      longitude: 14.5429808,
      address: 'Dolnoměcholupská 209/17, Praha 15',
      web: 'http://www.koalacafe.cz',
      cityPart: 'Hostivař',
    },
    {
      index: 7,
      id: 'mlyn-na-dobre-vode',
      name: 'Mlýn na Dobré vodě',
      image: 'restaurants.svg',
      gps: '50.0300175N, 14.5632119E',
      latitude: 50.0300175,
      longitude: 14.5632119,
      address: 'Na Dobré vodě 39, Praha',
      web: '',
      cityPart: 'Křeslice',
    },
    {
      index: 8,
      id: 'na-sancich',
      name: 'Na Šancích',
      image: 'restaurants.svg',
      gps: '50.0379197N, 14.5479481E',
      latitude: 50.0379197,
      longitude: 14.5479481,
      address: 'Turínská 1494/1, Praha 15',
      web: 'https://www.nasancich.cz/',
      cityPart: 'Hostivař',
    },
    {
      index: 9,
      id: 'pizzerie-milano',
      name: 'Pizzerie Milano',
      image: 'restaurants.svg',
      gps: '50.0464744N, 14.5559864E',
      latitude: 50.0464744,
      longitude: 14.5559864,
      address: 'Milánská 571, Praha 15',
      web: 'http://www.milano-pizzeria.cz/',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 10,
      id: 'zelenkova-cukrarna',
      name: 'Zelenkova cukrárna',
      image: 'zelenkova-cukrarna.png',
      gps: '50.0406150N, 14.5588369E',
      latitude: 50.040615,
      longitude: 14.5588369,
      address: 'Veronské nám. 403, Praha 15',
      web: 'http://www.zelenkovacukrarna.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 11,
      id: 'zmrzlinarna-micek',
      name: 'Zmrzlinárna Míček',
      image: 'micek.png',
      gps: '50.0478114N, 14.5515939E',
      latitude: 50.0478114,
      longitude: 14.5515939,
      address: 'U Golfu 565, Praha 15',
      web: 'https://www.golfhostivar.cz/cukrarna-zmrzlinarna/',
      cityPart: 'Horní Měcholupy',
    },
  ],
  groups: [
    {
      index: 0,
      id: 'auqa-sport-club',
      name: 'Aqua Sport Club',
      image: 'jedenactka.png',
      gps: '50.0386019N, 14.5016939E',
      latitude: 50.0386019,
      longitude: 14.5016939,
      address: 'Mírového hnutí 2385/3, Praha 11',
      web: 'https://www.aquasportclub.cz/kurzy-plavani/',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 1,
      id: 'baby-dance-praha',
      name: 'Baby dance Praha',
      image: 'baby-dance-praha.png',
      gps: '50.0314897N, 14.5284047E',
      latitude: 50.0314897,
      longitude: 14.5284047,
      address: 'Arkalycká 877/1, Praha 11',
      web: 'https://www.babydancepraha.cz',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 2,
      id: 'basta-fidli',
      name: 'Basta fidli',
      image: 'bastafidli.png',
      gps: '50.0360039N, 14.5565078E',
      latitude: 50.0360039,
      longitude: 14.5565078,
      address: 'Edisonova 429, Praha 10',
      web: 'http://bastafidli.net/pro-deti/',
      type: ['language', 'music', 'sport'],
      cityPart: 'Petrovice',
    },
    {
      index: 3,
      id: 'bemama',
      name: 'Bemama',
      image: 'groups.svg',
      gps: '50.0360039N, 14.5565078E',
      latitude: 50.0360039,
      longitude: 14.5565078,
      address: 'Edisonova 429, Praha 10',
      web: 'http://www.bemama.cz/cviceni-pro-rodice-s-detmi/',
      type: ['sport'],
      cityPart: 'Petrovice',
    },
    {
      index: 4,
      id: 'brick-by-brick',
      name: 'Brick by Brick',
      image: 'brick-by-brick.png',
      gps: '50.0406161N, 14.5588367E',
      latitude: 50.0406161,
      longitude: 14.5588367,
      address: 'Veronské náměstí 403, Praha 15',
      web: 'https://www.brickbybrick.cz/krouzky/',
      type: ['creative'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 5,
      id: 'centrum-vorisek',
      name: 'Centrum Voříšek',
      image: 'vorisek.png',
      gps: '50.0560117N, 14.5356736E',
      latitude: 50.0560117,
      longitude: 14.5356736,
      address: 'U Branek 674/9, Praha 15',
      web: 'https://centrumvorisek.cz',
      type: ['language', 'creative'],
      cityPart: 'Hostivař',
    },
    {
      index: 6,
      id: 'gymnathlon',
      name: 'Gymnathlon',
      image: 'gymnathlon.png',
      gps: '50.0409703N, 14.5502594E',
      latitude: 50.0409703,
      longitude: 14.5502594,
      address: 'Nad Přehradou 469, Praha 15',
      web: 'https://www.gymnathlon.cz/',
      type: ['sport'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 7,
      id: 'judo-academy',
      name: 'Judo Academy',
      image: 'groups.svg',
      gps: '50.0363156N, 14.5245722E',
      latitude: 50.0363156,
      longitude: 14.5245722,
      address: 'Květnového vítězství 85, Praha 11',
      web: 'https://www.judoprodeti.cz/',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 8,
      id: 'maly-muzikant',
      name: 'Malý muzikant',
      image: 'groups.svg',
      gps: '50.0360039N, 14.5565078E',
      latitude: 50.0360039,
      longitude: 14.5565078,
      address: 'Edisonova 429, Praha 10',
      web: 'https://www.malymuzikant.cz/#oskole',
      type: ['music'],
      cityPart: 'Petrovice',
    },
    {
      index: 9,
      id: 'muska-skolka',
      name: 'Muška školka',
      image: 'muska-skolka.png',
      gps: '50.0350603N, 14.5557514E',
      latitude: 50.0350603,
      longitude: 14.5557514,
      address: 'Edisonova 27/21, Praha 10',
      web: 'https://www.muskaskolka.cz/cs/odpoledni-krouzky/',
      type: ['creative', 'music', 'sport'],
      cityPart: 'Petrovice',
    },
    {
      index: 10,
      id: 'pilne-vcelky',
      name: 'Pilné včelky',
      image: 'pilne-vcelky.png',
      gps: '50.0349447N, 14.5223486E',
      latitude: 50.0349447,
      longitude: 14.5223486,
      address: 'Pacajevova 954/30, Praha 11',
      web: 'http://rcpilnevcelky.cz/rodinne-centrum/pravidelne-kurzy/',
      type: ['creative', 'music', 'sport'],
      cityPart: 'Háje',
    },
    {
      index: 11,
      id: 'plavacek',
      name: 'Plaváček',
      image: 'plavacek.png',
      gps: '50.0455339N, 14.5581889E',
      latitude: 50.0455339,
      longitude: 14.5581889,
      address: 'Milánská 311, Praha 15',
      web: 'https://www.plavani.com/kurzy',
      type: ['sport'],
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 12,
      id: 'sang',
      name: 'Sang Z.S. sport academy',
      image: 'sang.png',
      gps: '50.0358214N, 14.5223108E',
      latitude: 50.0358214,
      longitude: 14.5223108,
      address: 'Květnového vítězství 938/79, Praha 11',
      web: 'https://sang.cz/kurzy/Praha/',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 13,
      id: 'sokol-hostivar',
      name: 'Sokol Hostivař',
      image: 'sokol-hostivar.png',
      gps: '50.0558222N, 14.5352561E',
      latitude: 50.0558222,
      longitude: 14.5352561,
      address: 'U Branek 674/7, Praha 15',
      web: 'https://www.sokolhostivar.cz/',
      type: ['language', 'music', 'sport'],
      cityPart: 'Hostivař',
    },
    {
      index: 14,
      id: 'sokol-petrovice',
      name: 'Sokol Petrovice',
      image: 'groups.svg',
      gps: '50.0350828N, 14.5574344E',
      latitude: 50.0350828,
      longitude: 14.5574344,
      address: 'Bellova 56, Praha 10',
      web: 'http://www.sokol-petrovice.cz/index.php?id=cviceni-pro-deti',
      type: ['sport'],
      cityPart: 'Petrovice',
    },
    {
      index: 15,
      id: 'squash-point',
      name: 'Squash point',
      image: 'squash-point.png',
      gps: '50.0358214N, 14.5223108E',
      latitude: 50.0358214,
      longitude: 14.5223108,
      address: 'Květnového vítězství 938/79, Praha 11',
      web: 'https://www.squashpoint.cz/cviceni-pro-deti/',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 16,
      id: 'tenisova-skola-tallent',
      name: 'Tenisová škola Tallent',
      image: 'tallent.png',
      gps: '50.0279875N, 14.5347475E',
      latitude: 50.0279875,
      longitude: 14.5347475,
      address: 'K Milíčovu 674/2, Praha 11',
      web: 'https://www.tallent.cz/strediska/praha/zs-k-milicovu-2/',
      type: ['sport'],
      cityPart: 'Háje',
    },
    {
      index: 17,
      id: 'yamaha',
      name: 'Yamaha',
      image: 'yamaha.png',
      gps: '50.0413736N, 14.5605028E',
      latitude: 50.0413736,
      longitude: 14.5605028,
      address: 'Veronské náměstí 595, Praha 15',
      web: 'https://www.hudbaproradost.cz/programy-pro-deti',
      type: ['music'],
      cityPart: 'Horní Měcholupy',
    },
  ],
  kindergartens: [
    {
      index: 0,
      id: 'berusky',
      name: 'Berušky',
      image: 'kindergartens.svg',
      gps: '50.0453747N, 14.5540494E',
      latitude: 50.0453747,
      longitude: 14.5540494,
      address: 'Jaroměřská 206, Praha 15',
      web: 'http://www.mojeskolicka.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 1,
      id: 'broucci',
      name: 'Broučci',
      image: 'kindergartens.svg',
      gps: '50.0453747N, 14.5540494E',
      latitude: 50.0453747,
      longitude: 14.5540494,
      address: 'Jaroměřská 206, Praha 15',
      web: 'http://www.mojeskolicka.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 2,
      id: 'clovicek-hostivar',
      name: 'Človíček',
      image: 'clovicek.png',
      gps: '50.0487503N, 14.5369950E',
      latitude: 50.0487503,
      longitude: 14.536995,
      address: 'Kunická 1568, Praha 15',
      web: 'https://mshostivar.sportovniskoly.cz',
      cityPart: 'Hostivař',
    },
    {
      index: 3,
      id: 'clovicek-mecholupy',
      name: 'Človíček',
      image: 'clovicek.png',
      gps: '50.0413736N, 14.5605028E',
      latitude: 50.0413736,
      longitude: 14.5605028,
      address: 'Veronské náměstí 595, Praha 15',
      web: 'https://dsclovicek.sportovniskoly.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 4,
      id: 'dino-preschool',
      name: 'Dino Preschool',
      image: 'dino-school.png',
      gps: '50.0349433N, 14.5604164E',
      latitude: 50.0349433,
      longitude: 14.5604164,
      address: 'Bellova 352, Praha 10',
      web: 'https://dinoskola.cz/materska-skola/',
      cityPart: 'Petrovice',
    },
    {
      index: 5,
      id: 'do-lesa',
      name: 'DO LESA!',
      image: 'kindergartens.svg',
      gps: '50.0462336N, 14.5390842E',
      latitude: 50.0462336,
      longitude: 14.5390842,
      address: 'K Lesoparku, Praha 15',
      web: 'https://www.dolesa.net',
      cityPart: 'Hostivař',
    },
    {
      index: 6,
      id: 'frydolinek',
      name: 'Frydolínek',
      image: 'sokol-hostivar.png',
      gps: '50.0558222N, 14.5352561E',
      latitude: 50.0558222,
      longitude: 14.5352561,
      address: 'U Branek 674/7, Praha 15',
      web: 'http://www.sokolhostivar.cz/centrum/',
      cityPart: 'Hostivař',
    },
    {
      index: 7,
      id: 'kosik',
      name: 'Košík',
      image: 'ms-kosik.png',
      gps: '50.0447522N, 14.5192692E',
      latitude: 50.0447522,
      longitude: 14.5192692,
      address: 'K Horkám 504/40, Praha 15',
      web: 'http://www.mskosik-hostivar.cz/',
      cityPart: 'Hostivař',
    },
    {
      index: 8,
      id: 'montysek',
      name: 'Montýsek',
      image: 'montysek.png',
      gps: '50.0420967N, 14.5573572E',
      latitude: 50.0420967,
      longitude: 14.5573572,
      address: 'Bolevecká 474, Praha 15',
      web: 'https://www.montysek.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 9,
      id: 'muska',
      name: 'Muška',
      image: 'muska-skolka.png',
      gps: '50.0350603N, 14.5557514E',
      latitude: 50.0350603,
      longitude: 14.5557514,
      address: 'Edisonova 27/21, Praha 10',
      web: 'https://www.muskaskolka.cz/cs/',
      cityPart: 'Petrovice',
    },
    {
      index: 10,
      id: 'pilne-vcelky-skolka',
      name: 'Pilné včelky',
      image: 'pilne-vcelky.png',
      gps: '50.0349447N, 14.5223486E',
      latitude: 50.0349447,
      longitude: 14.5223486,
      address: 'Pacajevova 954/30, Praha 11',
      web: 'http://rcpilnevcelky.cz',
      cityPart: 'Háje',
    },
    {
      index: 11,
      id: 'rarasek',
      name: 'Rarášek',
      image: 'kindergartens.svg',
      gps: '50.0469700N, 14.5615733E',
      latitude: 50.04697,
      longitude: 14.5615733,
      address: 'Křimická 314, Praha 15',
      web: 'http://www.mojeskolicka.cz',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 12,
      id: 'seminko',
      name: 'Semínko',
      image: 'seminko.png',
      gps: '50.0482556N, 14.5200314E',
      latitude: 50.0482556,
      longitude: 14.5200314,
      address: 'Kubatova 32/1, Praha 15',
      web: 'https://www.toulcuvdvur.cz/stranka/o-seminku',
      cityPart: 'Hostivař',
    },
    {
      index: 13,
      id: 'slunicko',
      name: 'Sluníčka',
      image: 'slunicka.png',
      gps: '50.0496256N, 14.5317550E',
      latitude: 50.0496256,
      longitude: 14.531755,
      address: 'U břehu 638, Praha 15',
      web: 'http://slunicka.com',
      cityPart: 'Hostivař',
    },
    {
      index: 14,
      id: 'snopik',
      name: 'Snopík',
      image: 'snopik.png',
      gps: '50.0360039N, 14.5565078E',
      latitude: 50.0360039,
      longitude: 14.5565078,
      address: 'Edisonova 429, Praha 10',
      web: 'https://www.rc-snopik.cz',
      cityPart: 'Petrovice',
    },
    {
      index: 15,
      id: 'vorisek',
      name: 'Voříšek',
      image: 'vorisek.png',
      gps: '50.0560117N, 14.5356736E',
      latitude: 50.0560117,
      longitude: 14.5356736,
      address: 'U Branek 674/9, Praha 15',
      web: 'https://centrumvorisek.cz',
      cityPart: 'Hostivař',
    },
    {
      index: 16,
      id: 'wonderland',
      name: 'Wonderland',
      image: 'wonderland.png',
      gps: '50.0324878N, 14.5301567E',
      latitude: 50.0324878,
      longitude: 14.5301567,
      address: 'Kosmická 537, Praha 11',
      web: 'https://www.english-wonderland.cz/',
      cityPart: 'Háje',
    },
  ],
  doctors: [
    {
      index: 0,
      id: 'alblova-lucie',
      name: 'Alblová Lucie',
      image: 'doctors.svg',
      gps: '50.0724847N, 14.5084294E',
      latitude: 50.0724847,
      longitude: 14.5084294,
      address: 'Úvalská 3289/10a, Praha 10',
      web: 'https://www.fyzio-pro-deti.cz/',
      type: 'fyzioterapie',
      cityPart: 'Strašnice',
    },
    {
      index: 1,
      id: 'alfa-medica',
      name: 'Alfa medica',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'http://www.usni.cz/',
      type: 'orl',
      cityPart: 'Petrovice',
    },
    {
      index: 2,
      id: 'becvarova-nicola',
      name: 'Bečvářová Nicola',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.prahapetrovice.cz/oddeleni/logopedie',
      type: 'logopedie',
      cityPart: 'Petrovice',
    },
    {
      index: 3,
      id: 'czinnerova-milada',
      name: 'Czinnerová Milada',
      image: 'doctors.svg',
      gps: '50.0463006N, 14.5140050E',
      latitude: 50.0463006,
      longitude: 14.514005,
      address: 'Tesaříkova 1027/2, Praha 15',
      web:
        'https://www.firmy.cz/detail/1884067-mudr-milada-czinnerova-praha-hostivar.html',
      type: 'pediatrie',
      cityPart: 'Hostivař',
    },
    {
      index: 4,
      id: 'dentalni-centrum-hostivar',
      name: 'Dentální centrum Hostivař',
      image: 'doctors.svg',
      gps: '50.0525825N, 14.5410172E',
      latitude: 50.0525825,
      longitude: 14.5410172,
      address: 'Weilova 1270/4, Praha 15',
      web: 'http://stomatologiehostivar.cz/',
      type: 'stomatologie',
      cityPart: 'Hostivař',
    },
    {
      index: 5,
      id: 'dohnalova-dagmar',
      name: 'Dohnalová Dagmar',
      image: 'doctors.svg',
      gps: '50.0259925N, 14.5178011E',
      latitude: 50.0259925,
      longitude: 14.5178011,
      address: 'Opatovská 1763/11, Praha 11',
      web:
        'https://euc.cz/nase-zarizeni/kliniky/euc-klinika-praha-opatovska/prakticke-lekarstvi-pro-deti-a-dorost/mudr-dagmar-dohnalova/',
      type: 'pediatrie',
      cityPart: 'Chodov',
    },
    {
      index: 6,
      id: 'elpeko-1',
      name: 'Elpeko',
      image: 'doctors.svg',
      gps: '50.0424025N, 14.5872672E',
      latitude: 50.0424025,
      longitude: 14.5872672,
      address: 'Bečovská 656/14, Praha 22',
      web: 'https://www.rehabilitace-uhrineves.cz/',
      type: 'fyzioterapie',
      cityPart: 'Uhříněves',
    },
    {
      index: 7,
      id: 'elpeko-2',
      name: 'Elpeko',
      image: 'doctors.svg',
      gps: '50.0357508N, 14.5931744E',
      latitude: 50.0357508,
      longitude: 14.5931744,
      address: 'Přátelství 370/25, Praha 22',
      web: 'https://www.rehabilitace-uhrineves.cz/',
      type: 'fyzioterapie',
      cityPart: 'Uhříněves',
    },
    {
      index: 8,
      id: 'francova-vera',
      name: 'Francová Věra',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web:
        'https://katalog.praha11.cz/redakce/index.php?xuser=&lanG=cs&dr=1257',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
    {
      index: 9,
      id: 'fyzio-klinika',
      name: 'Fyzio klinika',
      image: 'doctors.svg',
      gps: '50.0326878N, 14.5132733E',
      latitude: 50.0326878,
      longitude: 14.5132733,
      address: 'Machkova 1642/2, Praha 11',
      web: 'https://www.fyzioklinika.cz/',
      type: 'fyzioterapie',
      cityPart: 'Chodov',
    },
    {
      index: 10,
      id: 'gerstmanova-helena',
      name: 'Gerstmanová Helena',
      image: 'doctors.svg',
      gps: '50.0241472N, 14.5213800E',
      latitude: 50.0241472,
      longitude: 14.52138,
      address: 'Tererova 1355/4, Praha 11',
      web:
        'https://katalog.praha11.cz/redakce/index.php?xuser=&lanG=cs&dr=1200',
      type: 'dermatologie',
      cityPart: 'Chodov',
    },
    {
      index: 11,
      id: 'hendrychova-zdenka',
      name: 'Hendrychová Zdeňka',
      image: 'doctors.svg',
      gps: '50.0259925N, 14.5178011E',
      latitude: 50.0259925,
      longitude: 14.5178011,
      address: 'Opatovská 1763/11, Praha 11',
      web:
        'https://euc.cz/nase-zarizeni/kliniky/euc-klinika-praha-opatovska/prakticke-lekarstvi-pro-deti-a-dorost/mudr-zdenka-hendrychova/',
      type: 'pediatrie',
      cityPart: 'Chodov',
    },
    {
      index: 12,
      id: 'janikova-iva',
      name: 'Janíková Iva',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.prahapetrovice.cz/oddeleni/ortopedie',
      type: 'ortopedie',
      cityPart: 'Petrovice',
    },
    {
      index: 13,
      id: 'jiranova-ivana',
      name: 'Jiráňová Ivana',
      image: 'doctors.svg',
      gps: '50.0548525N, 14.5315192E',
      latitude: 50.0548525,
      longitude: 14.5315192,
      address: 'U Hostivařského nádraží 1328/6, Praha 15',
      web:
        'https://www.firmy.cz/detail/12832376-mudr-ivana-jiranova-praha-hostivar.html',
      type: 'stomatologie',
      cityPart: 'Hostivař',
    },
    {
      index: 14,
      id: 'joura-michal',
      name: 'Joura Michal',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.prahapetrovice.cz/oddeleni/alergologie',
      type: 'alergologie',
      cityPart: 'Petrovice',
    },
    {
      index: 15,
      id: 'kokaisl-radek',
      name: 'Kokaisl Radek',
      image: 'doctors.svg',
      gps: '50.0802200N, 14.5012344E',
      latitude: 50.08022,
      longitude: 14.5012344,
      address: 'Plaňanská 573/1, Praha 10',
      web: 'https://www.rovnatka-praha10.cz',
      type: 'ortodoncie',
      cityPart: 'Malešice',
    },
    {
      index: 16,
      id: 'konigova-wachsmuth-ivana',
      name: 'Königová Wachsmuth Ivana',
      image: 'doctors.svg',
      gps: '50.0299642N, 14.5961011E',
      latitude: 50.02996,
      longitude: 14.5961011,
      address: 'Ke Kříži 1610/16, Praha 22',
      web: 'https://www.detskemecholupy.cz/',
      type: 'pediatrie',
      cityPart: 'Uhříněves',
    },
    {
      index: 17,
      id: 'kubartova-alexandra',
      name: 'Kubartová Alexandra',
      image: 'doctors.svg',
      gps: '50.0489983N, 14.5470072E',
      latitude: 50.0489983,
      longitude: 14.5470072,
      address: 'Golfová 910/10, Praha 15',
      web: 'https://mudr-kubartova-alexandra.zdravotniregistr.cz',
      type: 'pediatrie',
      cityPart: 'Hostivař',
    },
    {
      index: 18,
      id: 'lampa-roman',
      name: 'Lampa Roman',
      image: 'doctors.svg',
      gps: '50.0548525N, 14.5315192E',
      latitude: 50.0548525,
      longitude: 14.5315192,
      address: 'U Hostivařského nádraží 1328/6, Praha 15',
      web:
        'https://www.firmy.cz/detail/383811-mudr-roman-lampa-praha-hostivar.html',
      type: 'ortodoncie',
      cityPart: 'Hostivař',
    },
    {
      index: 19,
      id: 'lunakova-andrea',
      name: 'Luňáková Andrea',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.prahapetrovice.cz/oddeleni/orl',
      type: 'orl',
      cityPart: 'Petrovice',
    },
    {
      index: 20,
      id: 'majdent',
      name: 'Majdent',
      image: 'doctors.svg',
      gps: '50.0395861N, 14.5070925E',
      latitude: 50.0395861,
      longitude: 14.5070925,
      address: 'Majerského 2039/23, Praha 11',
      web: 'http://www.majdent.cz',
      type: 'stomatologie',
      cityPart: 'Chodov',
    },
    {
      index: 21,
      id: 'male-zdravi-haje',
      name: 'Malé zdraví ',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web: 'https://malezdravi.cz/male-zdravi-praha-haje',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
    {
      index: 22,
      id: 'male-zdravi-hostivar',
      name: 'Malé zdraví ',
      image: 'doctors.svg',
      gps: '50.0534150N, 14.5178375E',
      latitude: 50.053415,
      longitude: 14.5178375,
      address: 'Švehlova 1391/32, Praha 15',
      web: 'https://malezdravi.cz/male-zdravi-praha-hostivar',
      type: 'pediatrie',
      cityPart: 'Hostivař',
    },
    {
      index: 23,
      id: 'markalousova-jana',
      name: 'Markalousová Jana',
      image: 'doctors.svg',
      gps: '50.0401089N, 14.5650133E',
      latitude: 50.0401089,
      longitude: 14.5650133,
      address: 'Janovská 486, Praha 15',
      web: 'http://www.orlpraha-markalousova.cz/',
      type: 'orl',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 24,
      id: 'medicavera',
      name: 'Medicavera',
      image: 'doctors.svg',
      gps: '50.0463200N, 14.5589608E',
      latitude: 50.04632,
      longitude: 14.5589608,
      address: 'Boloňská 312/10, Praha 15',
      web: 'https://www.medicavera.cz/',
      type: 'fyzioterapie',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 25,
      id: 'melicharova-vera',
      name: 'Melicharová Věra',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.detskylekarpraha10.cz/',
      type: 'pediatrie',
      cityPart: 'Petrovice',
    },
    {
      index: 26,
      id: 'monada',
      name: 'Monada',
      image: 'doctors.svg',
      gps: '50.0331417N, 14.5258931E',
      latitude: 50.0331417,
      longitude: 14.5258931,
      address: 'Hviezdoslavova 519/10, Praha 11',
      web: 'https://www.monada.cz/',
      type: 'fyzioterapie',
      cityPart: 'Háje',
    },
    {
      index: 27,
      id: 'opatovska-pediatrie-haje',
      name: 'Opatovská pediatrie',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web: 'http://www.opatovskapediatrie.cz',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
    {
      index: 28,
      id: 'opatovska-pediatrie-chodov',
      name: 'Opatovská pediatrie',
      image: 'doctors.svg',
      gps: '50.0259925N, 14.5178011E',
      latitude: 50.0259925,
      longitude: 14.5178011,
      address: 'Opatovská 1763/11, Praha 11',
      web: 'http://www.opatovskapediatrie.cz',
      type: 'pediatrie',
      cityPart: 'Chodov',
    },
    {
      index: 29,
      id: 'ordinace-klinicke-logopedie',
      name: 'Ordinace klinické logopedie',
      image: 'doctors.svg',
      gps: '50.0241472N, 14.5213800E',
      latitude: 50.0241472,
      longitude: 14.52138,
      address: 'Tererova 1355/4, Praha 11',
      web: 'https://www.logopedie-tererovapraha4.cz/',
      type: 'logopedie',
      cityPart: 'Chodov',
    },
    {
      index: 30,
      id: 'orl-tererova',
      name: 'ORL Tererova',
      image: 'doctors.svg',
      gps: '50.0241472N, 14.5213800E',
      latitude: 50.0241472,
      longitude: 14.52138,
      address: 'Tererova 1355/4, Praha 11',
      web: 'http://www.orltererova.cz/',
      type: 'orl',
      cityPart: 'Chodov',
    },
    {
      index: 31,
      id: 'ortoart',
      name: 'OrtoArt ortodontická ordinace s.r.o.',
      image: 'doctors.svg',
      gps: '50.0562181N, 14.4970431E',
      latitude: 50.0562181,
      longitude: 14.4970431,
      address: 'Jabloňová 2992/8, Praha 10',
      web: 'http://www.poliklinikazahradnimesto.cz/odborn/stoma.html',
      type: 'ortodoncie',
      cityPart: 'Záběhlice',
    },
    {
      index: 32,
      id: 'pacltova-anna',
      name: 'Pacltová Anna',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web:
        'https://www.firmy.cz/detail/370582-mudr-anna-pacltova-praha-haje.html',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
    {
      index: 33,
      id: 'pacltova-dagmar',
      name: 'Pacltová Dagmar',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web:
        'https://katalog.praha11.cz/redakce/index.php?xuser=&lanG=cs&dr=1261',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
    {
      index: 34,
      id: 'pekárek-chodov',
      name: 'Pekárek Chodov',
      image: 'doctors.svg',
      gps: '50.0328297N, 14.4983956E',
      latitude: 50.0328297,
      longitude: 14.4983956,
      address: 'Starochodovská 1750/91, Praha 11',
      web: 'http://www.pekarek.dental/dum-zubni-pece-chodov',
      type: 'stomatologie',
      cityPart: 'Chodov',
    },
    {
      index: 35,
      id: 'pekarek-strasnice',
      name: 'Pekárek Strašnice',
      image: 'doctors.svg',
      gps: '50.0722111N, 14.4869442E',
      latitude: 50.0722111,
      longitude: 14.4869442,
      address: 'Nad olšinami 672/4, Praha 10',
      web: 'http://www.pekarek.dental/dum-zubni-pece-strasnice',
      type: 'stomatologie',
      cityPart: 'Strašnice',
    },
    {
      index: 36,
      id: 'petrikova-petra',
      name: 'Petrlíková Petra',
      image: 'doctors.svg',
      gps: '50.0463200N, 14.5589608E',
      latitude: 50.04632,
      longitude: 14.5589608,
      address: 'Boloňská 312/10, Praha 15',
      web: 'http://www.petrlikova.cz/',
      type: 'logopedie',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 37,
      id: 'polakova-marcela',
      name: 'Poláková Marcela',
      image: 'doctors.svg',
      gps: '50.0463200N, 14.5589608E',
      latitude: 50.04632,
      longitude: 14.5589608,
      address: 'Boloňská 312/10, Praha 15',
      web: 'https://www.mediclinic.cz/lekar/praha-10-horni-mecholupy-polakova',
      type: 'pediatrie',
      cityPart: 'Horní Měcholupy',
    },
    {
      index: 38,
      id: 'pospisilova-lenka',
      name: 'Pospíšilová Lenka',
      image: 'doctors.svg',
      gps: '50.0331697N, 14.5260722E',
      latitude: 50.0331697,
      longitude: 14.5260722,
      address: 'Hviezdoslavova 520/12, Praha 11',
      web: 'http://www.ocni-pospisilova.cz/',
      type: 'oftalmologie',
      cityPart: 'Háje',
    },
    {
      index: 39,
      id: 'rehabilitace-petrovice',
      name: 'Rehabilitace Petrovice',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'http://www.rehabilitacepetrovice.cz/',
      type: 'fyzioterapie',
      cityPart: 'Petrovice',
    },
    {
      index: 40,
      id: 'rehAktiv',
      name: 'RehAktiv',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'http://www.rehaktiv.cz/',
      type: 'fyzioterapie',
      cityPart: 'Petrovice',
    },
    {
      index: 41,
      id: 'schutova-vlasta',
      name: 'Schůtová Vlasta',
      image: 'doctors.svg',
      gps: '50.0463006N, 14.5140050E',
      latitude: 50.0463006,
      longitude: 14.514005,
      address: 'Tesaříkova 1027/2, Praha 15',
      web: 'https://www.mudrschutova-hostivar-pediatr.cz',
      type: 'pediatrie',
      cityPart: 'Hostivař',
    },
    {
      index: 42,
      id: 'steinerova-judita',
      name: 'Steinerová Judita',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web: 'http://www.steiner.cz/kozni/',
      type: 'dermatologie',
      cityPart: 'Háje',
    },
    {
      index: 43,
      id: 'snajdrova-jitka',
      name: 'Šnajdrová Jitka',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://www.prahapetrovice.cz/oddeleni/pediatrie',
      type: 'pediatrie',
      cityPart: 'Petrovice',
    },
    {
      index: 44,
      id: 'taxova-hana',
      name: 'Taxová Hana',
      image: 'doctors.svg',
      gps: '50.0286425N, 14.5215628E',
      latitude: 50.0286425,
      longitude: 14.5215628,
      address: 'Konstantinova 1479/1, Praha 11',
      web: 'http://www.taxova.infolekar.cz/',
      type: 'pediatrie',
      cityPart: 'Chodov',
    },
    {
      index: 45,
      id: 'vavreckova-anna',
      name: 'Vavřečková Anna',
      image: 'doctors.svg',
      gps: '50.0259925N, 14.5178011E',
      latitude: 50.0259925,
      longitude: 14.5178011,
      address: 'Opatovská 1763/11, Praha 11',
      web:
        'https://katalog.praha11.cz/redakce/index.php?xuser=&lanG=cs&dr=1003',
      type: 'pediatrie',
      cityPart: 'Chodov',
    },
    {
      index: 46,
      id: 'wagenknechtova-sarka',
      name: 'Wagenknechtová Šárka',
      image: 'doctors.svg',
      gps: '50.0387564N, 14.5597908E',
      latitude: 50.0387564,
      longitude: 14.5597908,
      address: 'Ohmova 271, Praha 10',
      web: 'https://klinicka-logopedie-bolonska.webnode.cz',
      type: 'logopedie',
      cityPart: 'Petrovice',
    },
    {
      index: 47,
      id: 'zborilova-eva',
      name: 'Zbořilová Eva',
      image: 'doctors.svg',
      gps: '50.0489983N, 14.5470072E',
      latitude: 50.0489983,
      longitude: 14.5470072,
      address: 'Golfová 910/10, Praha 15',
      web: 'https://www.ocni-zborilova.cz',
      type: 'oftalmologie',
      cityPart: 'Hostivař',
    },
    {
      index: 48,
      id: 'zikmundova-vitezslava',
      name: 'Zikmundová Vítězslava',
      image: 'doctors.svg',
      gps: '50.0333439N, 14.5284692E',
      latitude: 50.0333439,
      longitude: 14.5284692,
      address: 'Anny Drabíkové 534/3, Praha 11',
      web:
        'https://katalog.praha11.cz/redakce/index.php?xuser=&lanG=cs&dr=1263',
      type: 'pediatrie',
      cityPart: 'Háje',
    },
  ],
};
